import actions from './actions';
import { getters, state, mutations } from './mutations';

export default {
  mutations,
  getters,
  state,
  actions,
};
